//Modification provided by the Searchanise team, with any questions, contact us at feedback@searchanise.io
document.addEventListener('Searchanise.Loaded', function() {
    (function($) {
        if (Shopify.locale != 'it') {
            let hreflangHref = $(`link[hreflang="x-default"]`).attr('href');
            if (!hreflangHref) {
                console.error("snize: no x-default hreflang link found");
                return;
            }
            let snizeoglink = Searchanise.GetWidgets().collectionHrefData(hreflangHref).collection;
            if (!snizeoglink) {
                console.error("could not find link with original collection handle");
                return;
            }
            $(document).on('Searchanise.DataRequestBefore', function(event, type, params) {
                if (params && params.collection && snizeoglink) {
                    params.collection = snizeoglink;
                }
            });
        }
    })(window.Searchanise.$);
});